/* The landing page's purchase links keep variant and subscription choice on the PDP. */
if (!customElements.get('pl031-sticky')) {
  customElements.define('pl031-sticky', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      const hero = document.getElementById(this.dataset.hero);
      if (!hero || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(hero);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
